<!-- menu header navigation -->
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/">
    <img class="navbar-brand-logo" height="60" src="assets/img/header-logo.png" />
  </a>
  <button class="navbar-toggler" type="button" (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="navbar-collapse d-lg-flex" [class.d-none]="isNavbarCollapsed" id="navbarSupportedContent">

    <!-- logged out or no role -->
    <ul class="navbar-nav mr-auto">

      <li>
        <a [href]="domain.getCurrentDomain().url" target="_blank">
          {{'Open website' | translate}}
        </a>
      </li>

    </ul>

    <ul class="navbar-nav ml-auto mr-0">

      <!-- language switcher -->
      <li class="nav-item" ngbDropdown>
        <a class="nav-link cursor-pointer" ngbDropdownToggle>
          <span [ngbTooltip]="'Select your language' | translate" *ngIf="currentLanguage().flag">
            <span class="img-16 mt-n2">{{ currentLanguage().flag }}</span>
          </span>
        </a>
        <div ngbDropdownMenu class="dropdown-menu-right">
          <a ngbDropdownItem class="cursor-pointer" *ngFor="let language of supportedLanguages()" (click)="localeService.setCurrentLanguage(language.code)">
            <span class="img-16 mt-2 mr-2">{{ language.flag }}</span>
            <span class="text-capitalize">{{language.nativeName}}</span>
          </a>
        </div>
      </li>

      <!-- logged in -->
      <li class="nav-item" ngbDropdown *ngIf="loggedIn">
        <a class="nav-link cursor-pointer" ngbDropdownToggle>
          {{'Me' | translate}}
        </a>
        <div ngbDropdownMenu class="dropdown-menu-right">
          <a ngbDropdownItem data-cy="logout" (click)="Logout()">
            {{'Log out' | translate}}
          </a>
        </div>
      </li>

    </ul>

  </div>
</nav>
